// extracted by mini-css-extract-plugin
module.exports = {"root":"components-ui-tablist-root"};